import { useParams } from 'react-router-dom';
import { Help } from 'style-guide/Icons';
import Tooltip from 'style-guide/Tooltip';
import Text from 'style-guide/Typography/Text';
import Feedback from './Feedback';
import Introduction from './Introduction';
import CreateContentWrapper from './style/CreateContentWrapper';

const tooltipOverlayStyle = {
  backgroundColor: 'white',
  fontSize: '14px',
  color: 'black',
  width: '260px',
  boxShadow: '5px 10px 18px rgba(0, 0, 0, 0.25)',
  padding: '8px',
};

const CreateContent = ({ setPreviewData, setSurveyState, surveyState }) => {
  const { seriesName } = useParams();

  const isIntroduction = seriesName === 'introduction';

  return (
    <CreateContentWrapper className='content ph--32 mr--32'>
      <div className='pv--16 title-block d-flex align-items-center'>
        <Text variant={5}>{isIntroduction ? 'Introduction' : 'Series'}</Text>
        {!isIntroduction && (
          <Tooltip overlay='...up to 5 survey questions' placement='topLeft' overlayInnerStyle={tooltipOverlayStyle}>
            <Help height={16} width={16} className='help-icon ml--4' />
          </Tooltip>
        )}
      </div>

      {isIntroduction ? (
        <Introduction setPreviewData={setPreviewData} />
      ) : (
        <div className='mt--24'>
          <Feedback surveyState={surveyState} setPreviewData={setPreviewData} setSurveyState={setSurveyState} />
        </div>
      )}
    </CreateContentWrapper>
  );
};

export default CreateContent;
